var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"all-center"},[_c('b-col',{attrs:{"cols":"12","md":"6","lg":"5","xl":"4"}},[_c('login-form')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }